import {hitGoogleTagManager} from "../../tracking/google_tag_manager/init_google_tag_manager";
import {ForYouDisplayActions} from "../types/ForYouDisplayActions";
import {ForYouEventType} from "../types/ForYouEventType";

interface IForYouDisplayEvent {
    event: ForYouEventType;
    action: ForYouDisplayActions;
    region: string;
}

export const ForYouFormDisplayGtmEvent = (payload: IForYouDisplayEvent) => {
    const data = {
        event: payload.event,
        event_action: payload.action,
        event_category: payload.region
    };

    hitGoogleTagManager(data);
};

interface IForYouMapCheckboxEvent {
    mainRegionName: string;
    regionName: string;
    checked: boolean;
}

export const ForYouRegionChangeGtmEvent = (payload: IForYouMapCheckboxEvent) => {
    const data = {
        event: ForYouEventType.REGION,
        event_action: "checkbox",
        event_category: payload.mainRegionName,
        event_category2: payload.regionName,
        event_label: payload.checked ? "on" : "off"
    };

    hitGoogleTagManager(data);
};

interface IForYouCriteriaGtmPayload {
    rooms: string;
    area: string;
    budget: string;
    instalment: string;
}

export const ForYouCriteriaGtmEvent = (payload: IForYouCriteriaGtmPayload) => {
    const data = {
        event: ForYouEventType.CRITERIA,
        event_action: ForYouDisplayActions.APPLY,
        event_label: payload.rooms,
        event_category: payload.area,
        event_category2: payload.budget,
        event_category3: payload.instalment
    };

    hitGoogleTagManager(data);
};

export const ForYouSendGtmEvent = () => {
    hitGoogleTagManager({
        event: ForYouEventType.USER,
        event_action: "apply",
        value: 1,
        lead_source: "find_for_you"
    });
};

interface IForYouAdditionalGtmPayload {
    additionalAreas: string;
    kitchenType: string;
    floor: string;
    quarters: string;
    date: string;
    message: string;
}

export const ForYouAdditionalGtmEvent = (payload: IForYouAdditionalGtmPayload) => {
    const data = {
        event: ForYouEventType.ADDITIONAL,
        event_action: ForYouDisplayActions.APPLY,
        event_label: payload.additionalAreas,
        event_category: payload.kitchenType,
        event_category2: payload.floor,
        event_category3: payload.quarters,
        event_category4: payload.date,
        event_category5: payload.message
    };
    hitGoogleTagManager(data);
};
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/init_google_tag_manager";
import {ForYouDisplayActions} from "../types/ForYouDisplayActions";
import {ForYouEventType} from "../types/ForYouEventType";

interface IForYouDisplayEvent {
    event: ForYouEventType;
    action: ForYouDisplayActions;
    region: string;
}

export const ForYouFormDisplayGtmEvent = (payload: IForYouDisplayEvent) => {
    const data = {
        event: payload.event,
        event_action: payload.action,
        event_category: payload.region
    };

    hitGoogleTagManager(data);
};

interface IForYouMapCheckboxEvent {
    mainRegionName: string;
    regionName: string;
    checked: boolean;
}

export const ForYouRegionChangeGtmEvent = (payload: IForYouMapCheckboxEvent) => {
    const data = {
        event: ForYouEventType.REGION,
        event_action: "checkbox",
        event_category: payload.mainRegionName,
        event_category2: payload.regionName,
        event_label: payload.checked ? "on" : "off"
    };

    hitGoogleTagManager(data);
};

interface IForYouCriteriaGtmPayload {
    rooms: string;
    area: string;
    budget: string;
    instalment: string;
}

export const ForYouCriteriaGtmEvent = (payload: IForYouCriteriaGtmPayload) => {
    const data = {
        event: ForYouEventType.CRITERIA,
        event_action: ForYouDisplayActions.APPLY,
        event_label: payload.rooms,
        event_category: payload.area,
        event_category2: payload.budget,
        event_category3: payload.instalment
    };

    hitGoogleTagManager(data);
};

export const ForYouSendGtmEvent = () => {
    hitGoogleTagManager({
        event: ForYouEventType.USER,
        event_action: "apply",
        value: 1,
        lead_source: "find_for_you"
    });
};

interface IForYouAdditionalGtmPayload {
    additionalAreas: string;
    kitchenType: string;
    floor: string;
    quarters: string;
    date: string;
    message: string;
}

export const ForYouAdditionalGtmEvent = (payload: IForYouAdditionalGtmPayload) => {
    const data = {
        event: ForYouEventType.ADDITIONAL,
        event_action: ForYouDisplayActions.APPLY,
        event_label: payload.additionalAreas,
        event_category: payload.kitchenType,
        event_category2: payload.floor,
        event_category3: payload.quarters,
        event_category4: payload.date,
        event_category5: payload.message
    };
    hitGoogleTagManager(data);
};
